<app-header></app-header>
<a id="leftnav" class="vcal-btn"><span>Menu</span></a>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="cp-main-sec">
  <div class="cp-herobanner">
    <img src="assets/images/cpbanner.png" alt="" />
  </div>

  <div class="right-sec gm-right-sec" [class.right-slide]="isClassAdded">
    <div class="gm-right-sec-bg">
      <div class="gm-sec-heading">
        <div class="gm-title">
          @if (game_details) {
            <h2>{{ game_details.Gamename }}</h2>
            <p>{{ game_details.game_system || 'No game system' }} · Map: {{ game_details.map_name || '—' }}</p>
          } @else if (loading) {
            <span class="gm-skel gm-skel-title" aria-hidden="true"></span>
            <span class="gm-skel gm-skel-line" aria-hidden="true"></span>
            <span class="visually-hidden">Loading the game…</span>
          }
        </div>
        <div class="gm-btn-sec">
          <button type="button" class="btn btn-outline" (click)="goBack()">Back to games</button>
          <button type="button" class="btn btn-green" [disabled]="!game_details" (click)="playgame(game_details, acceptedChar_details)">Play</button>
        </div>
      </div>

      @if (game_details) {
        <div class="game-detail-sec">
          <div class="gd-box">
            <h3>Game details</h3>
            <ul>
              <li><span>Game name</span> {{ game_details.Gamename }}</li>
              <li><span>Genre</span> {{ game_details.game_genre || 'None' }}</li>
              <li><span>Map</span> {{ game_details.map_name || '—' }}</li>
              <li><span>Players</span> {{ seatedCount }} of {{ acceptedChar_details?.length || 0 }}</li>
              <li><span>Total party level</span> {{ game_details.partylevel || 0 }}</li>
              <li><span>Average level</span> {{ game_details.Averagelevel || 0 }}</li>
            </ul>
          </div>
          <div class="gh-box">
            <h3>Game history</h3>
            <ul>
              <li><span>First played</span> {{ game_details.FirstPlayed || 'Not played yet' }}</li>
              <li><span>Journal entries</span> {{ game_details.JournalEntries || 0 }}</li>
            </ul>
          </div>
          <button type="button" class="gd-token" (click)="uploadPartyToken(game_details)" title="Change the party token">
            <h5>Party token</h5>
            <div class="image-container-token">
              <img [src]="game_details.partytoken ? imageurl + game_details.partytoken : 'assets/images/ac-token-game.png'" alt="Party token" />
            </div>
            <span class="gd-upload-sec">
              <img src="assets/icons/icon-upload-outline.svg" alt="" />
              Change token
            </span>
          </button>
        </div>
      } @else if (loading) {
        <div class="game-detail-sec" aria-hidden="true">
          <div class="gd-box gm-skel-card"><span class="gm-skel gm-skel-line"></span><span class="gm-skel gm-skel-block"></span></div>
          <div class="gh-box gm-skel-card"><span class="gm-skel gm-skel-line"></span><span class="gm-skel gm-skel-block"></span></div>
          <div class="gd-token gm-skel-card"><span class="gm-skel gm-skel-round"></span></div>
        </div>
      } @else if (loadError) {
        <section class="gm-card gm-load-error">
          <h4>We couldn't load this game</h4>
          <p>Check your connection and try again, or go back to your games.</p>
          <div class="gm-card-actions">
            <button type="button" class="btn btn-outline btn-sm" (click)="goBack()">Back to games</button>
            <button type="button" class="btn btn-dark btn-sm" (click)="loading = true; loadError = false; gamedetailbygameid(game_id)">Try again</button>
          </div>
        </section>
      }

      @if (loading) {
        <section class="gm-card" aria-hidden="true">
          <span class="gm-skel gm-skel-line"></span>
          <div class="wt-seat-list">
            @for (n of [1, 2, 3, 4, 5, 6, 7, 8]; track n) { <span class="gm-skel gm-skel-row"></span> }
          </div>
        </section>
      } @else if (game_details) {
      <!-- the party: one row per seat (same rows as the start window) -->
      <section class="gm-card">
        <div class="gm-card-head">
          <h4>Players <span class="wt-seat-count">{{ seatedCount }} of {{ acceptedChar_details?.length || 0 }} seated</span></h4>
          <div class="gm-card-actions">
            @if (seatedCount > 0) {
              <button type="button" class="btn btn-outline btn-sm" (click)="openCharacterDeleteConfirmModal(false)"
                [disabled]="listofRemoveCharacters.length === 0">Remove selected</button>
            }
            <button type="button" class="btn btn-dark btn-sm" (click)="openInviteModal(game_details)">Invite players</button>
          </div>
        </div>
        @if (acceptedChar_details?.length > 0) {
          <div class="wt-seat-list">
            @for (char of acceptedChar_details; track $index; let i = $index) {
              @if (char.character_id) {
                <label class="wt-seat">
                  <input type="checkbox" [checked]="listofRemoveCharacters.includes(char.character_id)"
                    (change)="onPlayerRemoveTick(char)" [attr.aria-label]="'Select ' + char.nickname" />
                  <span class="wt-seat-no">{{ i + 1 }}</span>
                  <span class="wt-seat-main">
                    <span class="wt-seat-name">{{ char.nickname }} {{ char.last_name }}</span>
                    <span class="wt-seat-meta">@if (char.user_name) {{{ char.user_name }} · }Level {{ char.primary_class_level }} {{ char.primary_class }}@if (char.email) { · {{ char.email }}}</span>
                  </span>
                </label>
              } @else {
                <div class="wt-seat is-open">
                  <span class="wt-seat-no">{{ i + 1 }}</span>
                  <span class="wt-seat-open">Open seat</span>
                </div>
              }
            }
          </div>
        } @else {
          <p class="gm-empty">No players yet.</p>
        }
      </section>

      <!-- invitations: pending (selectable) and declined -->
      <section class="gm-card">
        <div class="gm-card-head">
          <h4>Invitations</h4>
          @if (pendingInvitation?.length > 0) {
            <div class="gm-card-actions">
              <button type="button" class="btn btn-outline btn-sm" (click)="openUninviteModal($event, game_details)"
                [disabled]="selectedPendingInvitationMails.length === 0">Uninvite</button>
              <button type="button" class="btn btn-dark btn-sm"
                (click)="resendInvitation(game_details, selectedPendingInvitationMails)"
                [disabled]="sending || selectedPendingInvitationMails.length === 0">Resend invite</button>
            </div>
          }
        </div>

        <h5 class="gm-sub-head">Pending</h5>
        @if (pendingInvitation?.length > 0) {
          <div class="wt-seat-list">
            @for (inv of pendingInvitation; track inv.email) {
              <label class="wt-seat">
                <input type="checkbox" [checked]="selectedPendingInvitationMails.includes(inv.email)"
                  (change)="onCheckboxChange($event, inv.email)" [attr.aria-label]="'Select ' + inv.email" />
                <span class="wt-seat-main"><span class="wt-seat-name">{{ inv.email || 'Unknown' }}</span></span>
              </label>
            }
          </div>
        } @else {
          <p class="gm-empty">No pending invitations.</p>
        }

        <h5 class="gm-sub-head">Declined</h5>
        @if (rejectedCharDetails?.length > 0) {
          <div class="wt-seat-list">
            @for (inv of rejectedCharDetails; track $index) {
              <div class="wt-seat is-static">
                <span class="wt-seat-main"><span class="wt-seat-name">{{ inv.email }}</span></span>
                <span class="wt-seat-badge">Declined</span>
              </div>
            }
          </div>
        } @else {
          <p class="gm-empty">No declined invitations.</p>
        }
      </section>
      }

      <section class="gm-card map-sec">
        <h4>Map{{ game_details?.map_name ? ': ' + game_details.map_name : '' }}</h4>
        <div class="bgtngrops">
          @for (btn of filterlayers(layerlist); track btn) {
            <div class="btn-group-toggle" data-toggle="buttons">
              <label class="btn headbtn"
                [ngClass]="[ btn.checked ? 'active ' : '', btn.label?.toLowerCase() === 'zones' ? 'disabled btn-grey active' : 'btn-secondary']">
                <input type="checkbox" [checked]="btn.checked" (change)="changeToggleLayer(btn)"
                  [disabled]="btn.label?.toLowerCase() === 'zones'" />
                {{ btn.label }}
              </label>
            </div>
          }
        </div>
        <div class="map" #map></div>
        <div class="map-wrapper"
          [ngStyle]="{'visibility': !isCityCode ? 'hidden' : 'visible', 'height': isCityCode ? '400px' : '0vh'}">
          <div id="map1" class="h-100" #cityMap></div>
        </div>
      </section>

      @if (game_details) {
      <section class="gm-card gm-danger">
        <div>
          <h4>Disband party</h4>
          <p>Ends this party for everyone. Pins you placed move into each character's own journey timeline.</p>
        </div>
        <button type="button" class="btn btn-danger" (click)="openCharacterDeleteConfirmModal(true)">Disband party</button>
      </section>
      }
    </div>
  </div>

  <app-footer></app-footer>
</div>
